import { ChargebacksQueueFields } from "globalConstants";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
} from "validators";

const { ChargebacksAmount, ChargebacksAmountFrom, ChargebacksAmountTo } =
	ChargebacksQueueFields;

const chargebacksAmount = ({ formName = "" }) => ({
	name: ChargebacksAmount.name,
	type: "numeric-range" as const,
	placeholder: "Chargebacks Amount, $",
	normalize: commaAndFloat2Normalizer,
	normalizeOnBlur: floatWithComma2Normalizer,
	nameInputFrom: ChargebacksAmountFrom.name,
	nameInputTo: ChargebacksAmountTo.name,
	title: "Please Select the Amount Range",
	addon: "$" as const,
	formName,
	groupColumns: [
		{
			name: ChargebacksAmountFrom.name,
			formatLabel: value =>
				`${
					ChargebacksAmountFrom.displayName
				}: ${floatWithComma2Normalizer(value)}`,
		},
		{
			name: ChargebacksAmountTo.name,
			formatLabel: value =>
				`${
					ChargebacksAmountTo.displayName
				}: ${floatWithComma2Normalizer(value)}`,
		},
	],
});

export default chargebacksAmount;
